import AnimatedElement from "../../components/content/textAnimation/page";
import DeviceListing from "../../components/content/deviceListing";

function Products() {
  return (
    <div className="px-2 pt-8 pb-4 md:py-16">
      <AnimatedElement animationClass="animate__fadeInDown" delay={0}>
        <h2 className="text-center sm:mb-24 text-2xl min-[480px]:text-4xl poppins_regular">
          Mobi POS Devices
        </h2>
      </AnimatedElement>

      <div className="max-w-screen-xl mx-auto p-4">
        <DeviceListing />
      </div>
    </div>
  );
}

export default Products;
